

























































import { Component } from 'vue-property-decorator';
import { store } from '../store';
import { StarMoneyImportJson, StarMoneyImportState } from '../json';
import { sortByFullName, getFullName, UserPermission } from '@/modules/user';
import { HeaderConfig, EntityList, ListAction } from '@/base';

@Component<List>({
  created()
  {
    this.init();
  },
  methods: {
    getFullName,
  },
})
export default class List extends EntityList<StarMoneyImportJson, typeof store>
{
  protected hasDeletePermission(): boolean {
    return this.hasPermission(UserPermission.ACCOUNTING_DELETE);
  }

  /**
   * The store to the items.
   */
  protected readonly store = store;

  public sortState = [{ property: 'createDate', desc: true  }];

  /**
   * Returns the list of actions to display in the table.
   */
  protected getActions(): ListAction<StarMoneyImportJson>[]
  {
    const actions = [];
    if (this.hasDeletePermission()) {
      actions.push(this.getActionDelete());
    }
    return actions;
  }

  /**
   * Values of filter form.
   */
  protected readonly filters = {
    fileName: '',
    importState: null as StarMoneyImportState | null,
    uploadedAtFrom: null as Date | null,
    uploadedAtTo: null as Date | null,
  };

  /**
   * Returns the columns of the table (excluding actions and id).
   */
  protected getColumns(): HeaderConfig[]
  {
    return [
      {
        value: 'fileName',
        text: this.$t('list.header.fileName').toString(),
      },
      {
        value: 'importState',
        text: this.$t('list.header.importState').toString(),
      },
      {
        value: 'user',
        text: this.$t('list.header.uploadedBy').toString(),
        sort: (a, b) => sortByFullName(a, b, this.$i18n.locale),
      },
      {
        value: 'createDate',
        text: this.$t('list.header.uploadedAt').toString(),
      },
    ];
  }

  protected getDeleteConfirmationMessage(item: StarMoneyImportJson): { title?: string; message: string }
  {
    const args = Object.assign({ item });
    return {
      title: this.$t('list.delete.title', args).toString(),
      message: this.$t('list.delete.message', args).toString(),
    };
  }

  private readonly StarMoneyImportState = StarMoneyImportState;
}
